import { create } from 'zustand';

import type { User } from './types';

interface AuthState {
  currentUser: User | null;
  setCurrentUser: (user: User | null) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  currentUser: null,
  setCurrentUser: (user) => {
    set({ currentUser: user });
  },
  clear: () => {
    set({ currentUser: null });
  },
}));
